import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Authority from "./components/Authority";
import Problem from "./components/Problem";
import Solution from "./components/Solution";
import Process from "./components/Process";
import Differentiation from "./components/Differentiation";
import CTASection from "./components/CTASection";
import ContactSection from "./components/ContactSection";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import SEOJsonLD from "@/components/feature/SEOJsonLD";

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://emcalu.com';

const homeSchema: Record<string, unknown> = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${siteUrl}/#organization`,
      "name": "EmCaLu AI Agency",
      "url": siteUrl,
      "email": "alex@emcalu.com",
      "logo": {
        "@type": "ImageObject",
        "url": `${siteUrl}/logo.png`
      },
      "description": "AI-powered market expansion and sales agency helping Western companies enter and dominate Eastern European markets (Romania, Moldova, CEE) with local expertise and intelligent sales systems.",
      "areaServed": [
        { "@type": "Place", "name": "Romania" },
        { "@type": "Place", "name": "Moldova" },
        { "@type": "Place", "name": "Eastern Europe" },
        { "@type": "Place", "name": "CEE" }
      ],
      "sameAs": [
        "https://www.linkedin.com/company/109861916/"
      ],
      "knowsAbout": [
        "B2B Sales Consulting",
        "Market Entry Strategy",
        "AI Sales Systems",
        "Lead Generation",
        "Eastern European Business"
      ]
    },
    {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      "url": siteUrl,
      "name": "EmCaLu AI Agency",
      "description": "AI-powered market expansion for Eastern Europe",
      "publisher": { "@id": `${siteUrl}/#organization` },
      "inLanguage": "en"
    },
    {
      "@type": "WebPage",
      "@id": `${siteUrl}/#webpage`,
      "url": siteUrl,
      "name": "EmCaLu AI Agency – AI-Powered Sales & Market Entry for Eastern Europe",
      "description": "EmCaLu AI Agency helps Western companies build sales pipelines and win clients in Eastern Europe using AI-powered systems and local expertise.",
      "isPartOf": { "@id": `${siteUrl}/#website` },
      "about": { "@id": `${siteUrl}/#organization` },
      "inLanguage": "en",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": siteUrl
          }
        ]
      }
    },
    {
      "@type": "ProfessionalService",
      "@id": `${siteUrl}/#professionalservice`,
      "name": "EmCaLu AI Agency",
      "url": siteUrl,
      "email": "alex@emcalu.com",
      "provider": { "@id": `${siteUrl}/#organization` },
      "serviceType": [
        "Market Entry Strategy",
        "B2B Outreach & Lead Generation",
        "Sales Calls & Qualification",
        "Deal Closing Support",
        "AI-Powered Follow-Up Systems"
      ],
      "areaServed": [
        { "@type": "Place", "name": "Romania" },
        { "@type": "Place", "name": "Moldova" },
        { "@type": "Place", "name": "Eastern Europe" },
        { "@type": "Place", "name": "France" },
        { "@type": "Place", "name": "Germany" },
        { "@type": "Place", "name": "United Kingdom" }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "B2B AI Sales & Market Entry Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Market Validation & Entry Strategy"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "B2B Outreach & Lead Generation"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "AI-Powered Follow-Up Systems"
            }
          }
        ]
      }
    }
  ]
};

export default function Home() {
  return (
    <main className="bg-[#080808]">
      <SEOJsonLD schema={homeSchema} id="json-ld-home" />
      <Navbar />
      <Hero />
      <Authority />
      <Problem />
      <Solution />
      <Process />
      <Differentiation />
      <CTASection />
      <ContactSection />
      <FinalCTA />
      <Footer />
    </main>
  );
}
